import { MfaModel } from './../../models/account-ledger.model';
import { MyAccountService } from './../../services/myAccount.service';
import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { AuthService } from '../../services/auth.service';
import { MfaAuthenticationComponent } from '../mfa-authentication/mfa-authentication.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-enable-mfa',
  templateUrl: './enable-mfa.component.html',
  styleUrls: ['./enable-mfa.component.css']
})
export class EnableMfaComponent implements OnInit {

  sendCodeOption = 'Mobile';  // default set to mobile
  emailAddress: string;
  mobileNumber: string;
  isEmailExist = false;
  isMobileExist = false;
  updateMfaModel: MfaModel = <MfaModel>{};

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private myAccountService: MyAccountService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EnableMfaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.emailAddress = this.data.emailAddress;
    this.mobileNumber = this.data.mobileNumber;
    this.isEmailExist = !!this.emailAddress;
    this.isMobileExist = !!this.mobileNumber;

    if (!this.data.mfaOption && this.data.mfaOption === 'E') {
      this.sendCodeOption = 'Email';
    }

    setTimeout(() => {
      if (this.isEmailExist && !this.isMobileExist) {
        this.sendCodeOption = 'Email';
        this.commonService.implementToast('Please fill your mobile number to enable send MFA OTP to your mobile', 'Info');
      } else if (!this.isEmailExist && this.isMobileExist) {
        this.sendCodeOption = 'Mobile';
        this.commonService.implementToast('Please fill your email address to enable send MFA OTP to your email', 'Info');
      } else if (!this.isEmailExist && !this.isMobileExist) {
        this.sendCodeOption = '';
        this.commonService.implementToast('Please fill your mobile number or email to enable MFA', 'Info');
      }
    }, 1000);

  }

  enableMFACode(): void {
      // if (this.sendCodeOption === 'Mobile' && !this.mobileNumber) {
      //     this.commonService.implementToast('Please enter mobile number', 'Info');
      //     return;
      // }
      // if (this.sendCodeOption === 'Email') {
      //   if (!this.emailAddress) {
      //     this.commonService.implementToast('Please enter email address', 'Info');
      //     return;
      //   } else if (!this.emailIsValid(this.emailAddress)) {
      //     this.commonService.implementToast('Email address is not valid', 'Error');
      //     return;
      //   }

      // }
      if (this.sendCodeOption === '') {
        this.commonService.implementToast('Please fill your mobile number or email address to enable MFA', 'Info');
        return;
      }


      const mfaType = this.sendCodeOption.charAt(0).toUpperCase();
      this.updateMfaModel.mfaEnabled = mfaType;
      this.updateMfaModel.mobile = this.mobileNumber;
      this.updateMfaModel.email = this.emailAddress;
      this.authService.sendMfaRegistrationCode(this.updateMfaModel).subscribe((res: any) => {
        if (res === true) {
          const dialogRef = this.dialog.open(MfaAuthenticationComponent, {
            width: '400px',
            data: {
              sendMethod: this.sendCodeOption,
              mobile: this.mobileNumber,
              email: this.emailAddress
            }
          });

          dialogRef.afterClosed().subscribe(result => {
             if (result) {

               this.myAccountService.UpdateUserMFAOption(this.updateMfaModel).subscribe((data: any) => {
                 if (data.status === true) {
                   this.commonService.implementToast('Multi-Factor Authentication enabled successfully.', 'Success');
                   this.dialogRef.close(this.sendCodeOption);
                 } else {
                  this.commonService.implementToast('Unable to update MFA at this moment, please try again later.', 'Info');
                 }
               },
               (error: any) => {
                 console.error(error);
                 this.commonService.implementToast('Update MFA failed, please try again later.', 'Error');
               });
             }
          });
        } else {
          this.commonService.implementToast('Unable to resend OTP, please try again later.', 'Error');
        }

      },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast('Unable to resend OTP, please try again later.', 'Error');
      });

  }

  emailIsValid (email: string): boolean {
    return /\S+@\S+\.\S+/.test(email);
  }

  onCloseClick() {
    this.dialogRef.close(false);
  }
}
